import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const MAIN_CONTENT_ID = 'main-content';

export function useRouteTransitionFocus(): void {
  const { pathname } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // FR-003: never move focus on the initial mount — let the browser handle
    // first-load focus (URL bar, autofocus inputs, etc.).
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    document.getElementById(MAIN_CONTENT_ID)?.focus();
  }, [pathname]);
}
